/**
 * Проверяет скрипт выполняется на мобильной версии?
 * @public
 * @returns {boolean}
 */
export const checkIsMobile = () => {
  return window.is_mobile === true;
};

export const buildCustomEvent = function(name) {
  return new Event(name);
};

export const debounce = (f, ms) => {
  let isCooldown = false;
  return function() {
    if (isCooldown) return;
    f.apply(this, arguments);
    isCooldown = true;
    setTimeout(() => isCooldown = false, ms);
  };
};



// WEBPACK FOOTER //
// ./daily/assets/id/helpers.js